// import { createSelector } from "reselect";

export const getMembershipTypes = (state:any) => state.membershipType.membershipTypes
export const getMembershipType = (state:any) => state.membershipType.membershipType;
export const getIsLoading = (state:any) => state.membershipType.isLoading;
export const getStatus = (state:any) => state.membershipType.status;